import React from 'react';

const AWS_EKS = () => {
  return (
    <div>
      <h1>AWS_EKS</h1>
      <p>This is the AWS_EKS component.</p>
    </div>
  );
};

export default AWS_EKS;
